var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title-text"},[_vm._v(" NEL Map ")]),_vm._v(" "),_c('div',[_c('svg'),_vm._v(" "),_c('img',{attrs:{"src":"https://datagovsg.github.io/ttt-frontend/dist/nel-map.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e576fcd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trainmap.vue
// module id = 741
// module chunks = 0